import request from "@/utils/request";

export function search(param) {
  return request({
    url: "api/search/" + param,
    method: "get"
  });
}
